"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentStatus = void 0;
var ConsentStatus;
(function (ConsentStatus) {
    ConsentStatus[ConsentStatus["rejected"] = 0] = "rejected";
    ConsentStatus[ConsentStatus["accepted"] = 1] = "accepted";
})(ConsentStatus || (exports.ConsentStatus = ConsentStatus = {}));
